if (!window.Eurus.loadedScript.includes('product-recommendations.js')) {
  window.Eurus.loadedScript.push('product-recommendations.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductRecommendations', {
        loading: false,
        load(el, url) {
          console.log('rca: recommendations load start', { url });
          this.loading = true;
          fetch(url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');
              const performed = recommendations?.dataset?.recommendationsPerformed;
              const count = recommendations?.dataset?.recommendationsCount;

              console.log('rca: recommendations response', {
                hasRecommendations: Boolean(recommendations),
                htmlLength: text.length,
                performed,
                count
              });
              if (recommendations && recommendations.innerHTML.trim().length) {
                requestAnimationFrame(() => {
                  el.innerHTML = recommendations.innerHTML;
                });
                if (recommendations.classList.contains('main-product')) {
                  el.className += ' mb-5 border-y border-solid accordion empty:border-b-0';
                }
              } else {
                console.log('rca: recommendations empty', { url, performed, count });
              }
            })
            .finally(() => {
              this.loading = false;
            }) 
            .catch(e => {
              console.log('rca: recommendations error', e);
              console.error(e);
            });
        }
      });
    });
  });
}
